export default __webpack_public_path__ + "images/a7746b148d50990e07f57dfd959689a1.png";